<template>
  <div>
    <div class="content-bottom-padded">
      <el-row class="content-bottom-padded" :gutter="20">
        <el-col :span="10">
          <shop-select style="width:100%" distributors @update="storeSearch"
                       :shopIdDefault="params.distributor_id"></shop-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="params.merchant_category_id" size="mini" clearable placeholder="请选择分类">
            <el-option :key="0" :value="0" label="未分类"></el-option>
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.category_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input style="width:100%" size="mini" placeholder="请输入商品名称或者货号" v-model="params.keywords">
            <el-button slot="append" icon="el-icon-search" @click="goodsNumberSearch"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="params.distributor_id">
        <el-col :span="24">
          <el-button-group>
            <el-button type="primary" size="mini" @click="syncGoodsPrice()" icon="el-icon-upload">同步商品价格
            </el-button>
            <el-button type="primary" size="mini" @click="handleBatchOnline(true)" icon="el-icon-upload">批量上架
            </el-button>
            <el-button type="primary" size="mini" @click="handleBatchOnline(false)" icon="el-icon-download">批量下架
            </el-button>
            <el-button type="primary" size="mini" @click="addCategories" icon="el-icon-download">批量关联分类</el-button>
            <el-button type="primary" size="mini" @click="handleBatchDownload">商品码下载</el-button>
            <el-button type="primary" size="mini" @click="delItemsAction(true)" icon="el-icon-delete">刪除勾选商品</el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item,index) in tabList" :key="index" :label="item.name" :name="item.activeName">
        <el-table :data="list" style="width: 100%" :height="wheight-240" v-loading="loading" ref="multipleItemsTable"
                  @selection-change="handleItemsSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="handleSkuEdit(scope.row)">设置SKU</el-button>
            </template>
          </el-table-column>
          <el-table-column label="上下架操作" width="90">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_can_sale"
                         @change="switchStatusChange(scope.$index, scope.row, true)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="item_bn" label="商品货号" min-width="50">
            <template slot-scope="scope">
              {{ scope.row.item_bn }}
            </template>
          </el-table-column>
          <el-table-column prop="item_name" label="商品名称" min-width="160"></el-table-column>
          <el-table-column prop="item_bn" label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.pics[0]" style="width:50px;" alt="">
            </template>
          </el-table-column>
          <el-table-column label="店铺分类" min-with="120">
            <template slot-scope="scope">{{ scope.row.category_name ? scope.row.category_name : '未分类' }}</template>
          </el-table-column>
          <el-table-column label="关联分类" min-with="120">
            <template slot-scope="scope">
              <el-button type="text" @click="addCategories(scope.row)">编辑关联分类</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="商品价格" min-width="60">
            <template slot-scope="scope">
              {{ scope.row.price }}元
            </template>
          </el-table-column>
          <el-table-column label="库存" min-width="60">
            <template slot-scope="scope">
              {{ scope.row.store }}
            </template>
          </el-table-column>
          <el-table-column label="打包费" min-width="60">
            <template slot-scope="scope">
              {{ scope.row.packing_fee }}元
            </template>
          </el-table-column>
          <!-- <el-table-column label="使用线上库存">
            <template slot-scope="scope">
              <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.use_online_stock"
                         @change="switchStatusChange(scope.$index, scope.row, true)"></el-switch>
            </template>
          </el-table-column> -->
          <el-table-column label="搜索推荐">
            <template slot-scope="scope">
              <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.search_recommend"
                         @change="switchStatusChange(scope.$index, scope.row, true)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="approve_status" label="状态" min-width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.approve_status === 'onsale'" class="grid-content"> 前台可销售</div>
              <div v-else-if="scope.row.approve_status === 'offline_sale'" class="grid-content"> 可线下销售</div>
              <div v-else class="grid-content"> 不可销售</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="params.page"
            :page-sizes="[10,20,50]"
            :total="total_count"
            :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <sideBar :visible.sync="show_sideBar" title="编辑店铺sku配置" width="60">
      <slot>
        <el-table :data="itemSkuList" style="width: 100%" :height="wheight-240" v-loading="loading">
          <el-table-column prop="item_id" width="80" label="商品ID"></el-table-column>
          <el-table-column prop="item_bn" label="商品货号" width="80">
            <template slot-scope="scope">
              {{ scope.row.item_bn }}
            </template>
          </el-table-column>
          <el-table-column prop="item_name" label="商品名称" width="180"></el-table-column>
          <el-table-column prop="price" label="商品价格" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.item_id !== currentId">
                ¥{{ scope.row.price / 100 }}
                <i class="el-input__icon el-icon-edit" @click="editPrice(scope.row.item_id, scope.row.price)"></i>
              </div>
              <el-input v-else v-model="currentPrice" @blur="handleBlur(scope.$index,scope)" size="mini"
                        :ref="'input_' + scope.row.item_id"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="packing_fee" label="打包费" width="120">
            <template slot-scope="scope" >
              <div v-if="scope.row.item_id !== currentId2">
                ¥{{scope.row.packing_fee/100}}
                <i class="el-input__icon el-icon-edit" @click="editPackingFee(scope.row.item_id, scope.row.packing_fee)"></i>
              </div>
               <el-input v-else v-model="currentPackingFee" @blur="handleBlur2(scope.$index,scope)"  size="mini" :ref="'inputfee_' + scope.row.item_id"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="item_spec_desc" label="规格" width="100"></el-table-column>
          <el-table-column prop="store" label="库存" width="120">
            <template slot-scope="scope">
              <el-input v-if="editStore" v-model="scope.row.store"><i slot="suffix" class="el-input__icon el-icon-edit"></i>
              </el-input>
              <el-input v-else v-model="scope.row.store" disabled></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="approve_status" label="状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.approve_status === 'onsale'" class="grid-content"> 前台可销售</div>
              <div v-else-if="scope.row.approve_status === 'offline_sale'" class="grid-content"> 可线下销售</div>
              <div v-else class="grid-content"> 不可销售</div>
            </template>
          </el-table-column>
          <el-table-column label="上下架操作" width="180">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.is_can_sale" active-text="已上架" inactive-text="已下架"
                         @change="switchStatusChange(scope.$index, scope.row, false)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="更新库存" width="180">
            <template slot-scope="scope">
              <el-button type="primary" v-model="scope.row.store" @click="saveStore(scope.row.store,scope.row)" size="mini">更新库存</el-button>
              <el-button type="primary" size="mini" v-model="scope.row.store" @click="syncStore(scope.row.store,scope.row)">同步OMS库存</el-button>
            </template>
          </el-table-column>
        </el-table>
      </slot>
    </sideBar>
    <el-dialog :title="addCategoryTitle" :visible.sync="addCategoryVisible">
      <el-select multiple v-model="form.items_category_ids" palceholder="请选择" style="width: 100%;">
        <el-option
          v-for="item in categoryList"
          :key="item.id"
          :label="item.category_name"
          :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCategoryVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCategorySubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="titleSet" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="form" v-if="form.cancel == true">
        <el-form-item>
          <el-select v-model="form.category_ids" multiple style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.category_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-else>请确认您要删除已有分类?</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import store from '../../../store'
import {mapGetters} from 'vuex'
import shopSelect from '@/components/shopSelect'
import {
  getDistributorItems,
  delDistributorItems,
  updateDistributorItem,
  syncDistributorItemStock,
  getDistributorInfo
} from '../../../api/marketing'
import { getMerchantItemsCategory, addMerchantItemsAssociationsChange,syncCenterDistributorItemsList } from '../../../api/merchant'
import sideBar from '@/components/element/sideBar'

const getWxaCodeImg = url => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'arraybuffer',
      headers: {'Authorization': 'bearer ' + store.getters.token}
    }).then(data => {
      resolve(data.data)
    }).catch(error => {
      reject(error.toString())
    })
  })
}
export default {
  components: {
    shopSelect,
    sideBar
  },
  props: {
    isLoad: {
      // type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addCategoryTitle: '关联分类',
      addCategoryVisible: false,
      titleSet: '设置分类',
      categoryList: [],
      dialogFormVisible: false,
      itemCategoryList: [],
      show_sideBar: false,
      activeName: 'first',
      total_count: 0,
      loading: false,
      currentId: '',
      currentId2: '',
      currentPrice: '',
      currentPackingFee: '',
      distributorInfo:[],
      params: {
        page: 1,
        pageSize: 10,
        distributor_id: '',
        keywords: '',
        is_can_sale: '_all'
      },
      list: [],
      itemsChecked: [],
      tabList: [
        {name: '全部商品', value: null, activeName: 'first'},
        {name: '已上架', value: 'true', activeName: 'second'},
        {name: '未上架', value: 'true', activeName: 'third'}
      ],
      editStore: false,
      itemSkuList: [],
      itemSkuParam: {
        is_sku: 'true'
      },
      form: {
        item_ids: [],
        category_ids: '',
        items_category_ids: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    syncGoodsPrice(){
      this.$confirm('此操作更改此店铺的店铺商品价格。', '更新价格提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         syncCenterDistributorItemsList({number:this.distributorInfo.number}).then(response => {
            this.$message({type: 'success', message: '已经加入队列!'})
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    addCategories (data) {
      this.addCategoryVisible = true
      if (data.item_id) {
        this.form.item_ids = data.item_id // 要更新分类的商品
      } else {
        let ids = []
        this.itemsChecked.forEach(item => {
          ids.push(item.goods_id)
        })
        this.form.item_ids = ids // 要更新分类的商品
      }
      this.form.items_category_ids = data.items_category_ids // 已有分类集合
    },
    addCategorySubmit () {
      this.form.category_ids = this.form.items_category_ids // 现有分类集合
      this.form.distributor_id = this.params.distributor_id
      console.log(this.form)
      // 单个商品分类编辑
      addMerchantItemsAssociationsChange(this.form).then(res => {
        console.log(res.data)
        this.$message({
          type: 'success',
          message: '设置分类成功!'
        })
        this.addCategoryVisible = false
        this.params.page = 1
        this.getList()
      })
    },
    getCategoryList () {
      var _data = {}
      _data.distributor_id = this.params.distributor_id ? this.params.distributor_id : '34'
      _data.status = 1
      _data.pagesize = 200
      getMerchantItemsCategory(_data).then(response => {
        if (response.data.data) {
          this.categoryList = response.data.data.list
        }
      })
    },
    checkMerchant () {
      if (!this.distributorId || this.distributorId == 1) {
        this.$message({
          message: '请您先在右上角选择一个店铺后进行操作,若无店铺请先添加店铺!',
          type: 'error'
        })
        return false
      } else {
        return true
      }
    },
    storeSearch (val) {
      val && val.shop_id
      this.params.distributor_id = val.shop_id
      this.distributorId = val.shop_id
      this.params.page = 1
      this.getList()
    },
    handleBatchCategory (cancel) {
      if (!this.checkMerchant()) {
        return
      }
      if (this.itemsChecked.length <= 0) {
        this.$message({type: 'error', message: '请至少选择一个商品'})
        return
      } else {
        var ids = []
        this.itemsChecked.forEach(item => {
          ids.push(item.goods_id)
        })
        this.form.item_ids = ids
        this.form.cancel = cancel
      }
      this.dialogFormVisible = true
      if (this.form.cancel == true) {
        this.titleSet = '设置分类'
      } else {
        this.titleSet = '取消分类'
      }
    },
    onSubmit (formName) {
      if (this.form.cancel == true) {
        if (this.form.category_ids == '') {
          this.$message({type: 'error', message: '请选择分类'})
          return
        }
      }
      this.form.distributor_id = this.params.distributor_id
      console.log(this.form)
      addMerchantItemsAssociations(this.form).then(response => {
        this.$message({type: 'success', message: '设置分类成功!'})
        this.dialogFormVisible = false
        this.params.page = 1
        this.getList()
      })
    },
    handleBatchOnline (goods_can_sale) {
      if (this.itemsChecked.length <= 0) {
        this.$message({type: 'error', message: '请至少选择一个商品'})
        return
      }
      var goodsIds = []
      this.itemsChecked.forEach(item => {
        goodsIds.push(item.goods_id)
      })
      var form = {
        'distributor_id': this.params.distributor_id,
        'goods_id': JSON.stringify(goodsIds),
        'is_can_sale': goods_can_sale
      }
      this.updateDistributorItem(form)
    },
    handleSkuEdit (row) {
      if (!this.checkMerchant()) {
        return
      }
      if (row.is_total_store === false) {
        this.editStore = true
      } else {
        this.editStore = false
      }
      this.show_sideBar = true
      this.itemSkuParam.item_id = row.item_id
      this.itemSkuParam.distributor_id = this.params.distributor_id
      getDistributorItems(this.itemSkuParam).then(res => {
        this.itemSkuList = res.data.data.list
      })
    },
    handleClick (tab, event) {
      if (!this.checkMerchant()) {
        return
      }
      if (tab.name == 'second') {
        this.params.is_can_sale = true
      } else if (tab.name == 'third') {
        this.params.is_can_sale = false
      } else {
        this.params.is_can_sale = '_all'
      }
      this.params.page = 1
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getList()
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    getList () {
      this.loading = true
      getDistributorItems(this.params).then(response => {
        if (response.data.data.list) {
          this.list = response.data.data.list
          this.categoryList = response.data.data.category
          for (var i = 0; i < this.list.length; i++) {
            this.list[i].price = this.list[i].price / 100
            this.list[i].packing_fee = this.list[i].packing_fee / 100
          }
          this.total_count = parseInt(response.data.data.total_count)
        }
        this.getCategoryList()
      })
      this.loading = false
    },
    delItemsAction () {
      // console.log(this.distributorId)
      if (this.distributorId < 1) {
        this.$message({
          type: 'error',
          message: '请选择店铺!'
        })
      }
      if (this.itemsChecked.length <= 0) {
        this.$message({type: 'error', message: '请至少选择一个商品'})
      }
      var goodsIds = []
      this.itemsChecked.forEach(item => {
        goodsIds.push(item.default_item_id)
      })
      let data = {
        distributor_id: this.distributorId,
        item_ids: goodsIds
      }
      this.$confirm('此操作将永久删除该商品，如需恢复，请重新发布。', '删除商品提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delDistributorItems(data).then(response => {
          if (response.data.data.status === true) {
            console.log(response)
            this.$message({type: 'success', message: response.data.data.msg})
            this.params.page = 1
            this.getList()
          } else {
            this.$message({type: 'error', message: response.data.data.msg})
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleItemsSelectionChange (val) { // 商品选择
      this.itemsChecked = val
    },
    handleBatchDownload: function () {
      if (this.itemsChecked.length <= 0) {
        this.$message({
          type: 'error',
          message: '请至少选择一个商品!'
        })
        return
      }
      const zip = new JSZip()
      const cache = {}
      const promises = []
      var that = this
      that.itemsChecked.forEach(item => {
        var url = process.env.BASE_API + '/goods/distributionGoodsWxaCodeStream?item_id=' + item.itemId + '&distributor_id=' + this.params.distributor_id
        const promise = getWxaCodeImg(url).then(result_file => { // 下载文件, 并存成ArrayBuffer对象
          const file_name = item.itemName + '.png' // 获取文件名
          zip.file(file_name, result_file, {binary: true}) // 逐个添加文件
          cache[file_name] = result_file
        })
        promises.push(promise)
      })
      Promise.all(promises).then(() => {
        zip.generateAsync({type: 'blob'}).then(content => { // 生成二进制流
          FileSaver.saveAs(content, '店铺的商品小程序码(批量).zip') // 利用file-saver保存文件
        })
      })
    },
    updateDistributorItem (params) {
      if (!this.checkMerchant()) {
        return
      }
      updateDistributorItem(params).then(res => {
        this.getList()
        this.$message({
          type: 'success',
          message: '修改成功',
          duration: 1000
        })
      })
    },
    syncDistributorItemStock(params) {
      if (!this.checkMerchant()) {
        return
      }
      syncDistributorItemStock(params).then(res => {
        console.log(res.data.data)
        let oms_stock = res.data.data.oms_stock
        let update_at = res.data.data.updated
        this.getList()
        this.$message({
          type: 'success',
          message: '修改成功，OMS 库存为：' + oms_stock + '，OMS上次同步时间为：' + update_at,
          duration: 2000
        })
      })
    },
    editPrice (id, price) {
      this.currentId = id
      this.currentPrice = price / 100
      let self = this
      this.$nextTick(() => {
        self.$refs['input_' + id].focus()
      })
    },
    handleBlur (index, scope) {
      if (this.currentPrice * 100 == scope.row.price) {
        this.currentId = -1
        this.currentPrice = ''
        return
      }
      let form = {}
      form = {
        'distributor_id': this.params.distributor_id,
        'item_id': scope.row.item_id,
        'price': this.currentPrice * 100
      }
      this.updateDistributorItem(form)
      scope.row.price = this.currentPrice * 100
      this.currentId = -1
      this.currentPrice = ''
    },
    editPackingFee (id, price) {
      this.currentId2 = id
      this.currentPackingFee = price / 100
      let self = this
      this.$nextTick(() => {
        self.$refs['inputfee_' + id].focus()
      })
    },
    handleBlur2 (index, scope) {
      if (this.currentPackingFee * 100 == scope.row.packing_fee) {
        this.currentId2 = -1
        this.currentPackingFee = ''
        return
      }
      let form = {}
      form = {
        'distributor_id': this.params.distributor_id,
        'item_id': scope.row.item_id,
        'packing_fee': this.currentPackingFee * 100
      }
      this.updateDistributorItem(form)
      scope.row.packing_fee = this.currentPackingFee * 100
      this.currentId2 = -1
      this.currentPackingFee = ''
    },
    switchStatusChange (index, row, isDefault) {
      let form = {}
      if (isDefault) {
        form = {
          'distributor_id': this.params.distributor_id,
          'goods_id': row.goods_id,
          'is_can_sale': row.is_can_sale,
          'item_bn': row.item_bn,
          'search_recommend': row.search_recommend,
          'use_online_stock': row.use_online_stock
        }
      } else {
        form = {
          'distributor_id': this.params.distributor_id,
          'item_id': row.item_id,
          'is_can_sale': row.is_can_sale,
          'item_bn': row.item_bn,
          'search_recommend': row.search_recommend,
          'use_online_stock': row.use_online_stock
        }
      }
      this.updateDistributorItem(form)
    },
    goodsNumberSearch () {
      if (!this.checkMerchant()) {
        return
      }
      if (this.params.item_category) {
        this.params.item_category = this.params.item_category[this.params.item_category.length - 1]
      }
      console.log(this.params.item_category)
      this.params.page = 1
      this.getList()
    },
    async getDefaultDistributor (id) {
      let params = {distributor_id: id ? id : 0}
      let {data} = await getDistributorInfo(params)
      let distributor = data.data
      this.distributorInfo = data.data
      if (distributor) {
        return distributor
      } else {
        this.$router.go(-1)
      }
    },
    async getDistributorItemList () {
      let distributor = await this.getDefaultDistributor(this.params.distributor_id)
      if (!this.params.distributor_id && distributor) {
        this.params.distributor_id = distributor.distributor_id
      }
    },
    saveStore (store, row) {
      let form = {}
      form = {'distributor_id': this.params.distributor_id, 'item_id': row.item_id, 'store': store}
      this.updateDistributorItem(form)
    },
    // 手动同步 OMS 库存
    syncStore (store, row) {
      let form = {}
      form = {'distributor_id': this.params.distributor_id, 'item_id': row.item_id}
      this.syncDistributorItemStock(form)
    }
  },
  mounted () {
    if (this.$route.query.distributor_id) {
      this.distributorId = this.$route.query.distributor_id
    }
    this.$nextTick(() => {
      if (this.isLoad) {
        if (!this.distributorId) {
          this.distributorId = '34' // 默认选中大庆路二店
        }
        this.params.distributor_id = this.distributorId
        this.getList()
        this.getDistributorItemList()
        this.getCategoryList()
        this.loading = false
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// relmalllist.vue?404e669b